import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  description: string
  isOpen: boolean
  onClose: () => void
}

/** キャンペーン概要ダイアログ */
export const DialogCampaignDescription = memo(({ description, isOpen, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('home.summary', '概要')}>
      <HtmlContent html={description} variant="body1" className="mt-4 text-gray-700 whitespace-pre-wrap" />
    </Dialog>
  )
})
